import { apiClient } from "../API/axiosInstance";
import { CONFIG } from "../config";
import { store } from "../store";

export class UserService {
  static async checkBilling() {
    //check if billing is enabled

    if (!CONFIG.billing_enabled) return true;

    //if current path is /billing/limit-reached or /account, return
    if (
      window.location.pathname === "/billing/limit-reached" ||
      window.location.pathname === "/billing/register-card" ||
      window.location.pathname === "/billing/invoice-due" ||
      window.location.pathname === "/billing/success" ||
      window.location.pathname === "/billing/cancel" ||
      window.location.pathname === "/billing/subscription-success"
    )
      return;

    const response = await apiClient.get(`/billing/check`);
    const data = response.data;
    if (!data) return false;

    //check response message
    //card_required = redirect to /billing/register-card
    //limit_reached = redirect to /billing/limit-reached
    //billing_inactive = redirect to /billing/register-card

    if (data.message === "card_required") {
      window.location.href = "/billing/register-card";
      return false;
    }

    if (data.message === "limit_reached") {
      window.location.href = "/billing/limit-reached";
      return false;
    }

    if (data.message === "billing_inactive") {
      window.location.href = "/billing/register-card";
      return false;
    }

    return true;
  }

  static async upgradeSubscription(device_limit) {
    const response = await apiClient.get(`/billing/upgrade/${device_limit}`);
    return response.data;
  }

  static async fetchUser(email, sub) {
    //check email and sub are not null
    if (!email || !sub) return;

    const response = await apiClient.post("/user/", {
      email: email,
      sub: sub,
    });

    if (response.data) {
      //dispatch to users/update reducer
      store.dispatch({ type: "user/update", payload: response.data });
    }
  }

  static async getUserDevicesTotal(userId) {
    const response = await apiClient.get(`/user/${userId}/devices-total`);
    return response.data;
  }

  // API Key Management
  static async generateApiKey() {
    const response = await apiClient.get("/user/generate-api-key");
    return response.data;
  }

  static async createApiKey(name) {
    const payload = name?.trim() ? { name: name.trim() } : {};
    const response = await apiClient.post("/user/api-keys", payload);
    return response.data;
  }

  static async listApiKeys() {
    const response = await apiClient.get("/user/api-keys");
    return response.data;
  }

  static async revokeApiKey(apiKeyId) {
    await apiClient.delete(`/user/api-keys/${apiKeyId}`);
  }

  static async getApiKeyUsage() {
    const response = await apiClient.get("/user/api-key-usage");
    return response.data;
  }

  static async getApiKeyUsageHistory() {
    const response = await apiClient.get("/user/api-key-usage-history");
    return response.data;
  }
}
